<template>
  <div>
    <v-input placeholder="名称/像素高度/像素宽度"
             v-model="queryValue"
             style="width:200px;display:inline-block"></v-input>
    <v-button type="primary"
              @click="inintData">查找规格</v-button>
    <v-button type="primary"
              ghost
              @click="backManager"
              icon="left"
              style="float:right">返回列表</v-button>
    <div style="height:20px;"></div>
    <el-table :data="tableData"
              style="width: 100%">
      <el-table-column prop="spec_id"
                       label="规格ID">
      </el-table-column>
      <el-table-column prop="spec_name"
                       label="规格名称">
      </el-table-column>
      <el-table-column prop="px_size"
                       label="像素尺寸信息(宽高)">
      </el-table-column>
      <el-table-column prop="group_name"
                       label="所在分组名称">
      </el-table-column>
      <el-table-column prop="weights"
                       label="权重">
      </el-table-column>
      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     @click="handleClick(scope.row)"
                     size="small">修改</el-button>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      queryValue: this.$route.query.queryValue,
      tableData: []
    }
  },
  methods: {
    handleClick () {
      this.$router.push('/main/formatEdit')
    },
    backManager () {
      this.$router.push('/main/formatManager')
    },
    inintData () {
      if (this.queryValue === '') {
        this.$message['error']('请输入查询条件')
        return
      }
      axios.get('/dev/search_specs/' + this.queryValue)
        .then(res => {
          console.log(res.data)
          res.data.result.forEach(element => {
            element.px_size = element.px_size[0] + '*' + element.px_size[1]
          })
          this.tableData = res.data.result
        })
    }
  },
  created () {
    this.inintData()
  },
  mounted () {

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/format/format-query.vue